<template>
  <div class="big-screen-box">
    <div class="big-screen-box-head">
      <div class="big-screen-box-head-left">
        <div class="btn-box">
          <span
            class="btn"
            :class="[tag == 0 ? 'btn-active' : '']"
            @click="onBusiness"
            >工商系统式</span
          >
          <span
            class="btn"
            :class="[tag == 2 ? 'btn-active' : '']"
            @click="onRestaurant"
            >工商独立式</span
          >
          <span
            class="btn"
            :class="[tag == 1 ? 'btn-active' : '']"
            @click="onHome"
            >家用</span
          >
        </div>
        <div class="time-box">
          <div>{{ `${times.hour}:${times.minute}:${times.second}` }}</div>
          <div>
            <span>{{ times.strDate }}</span>
            <span>{{ `${times.year}-${times.month}-${times.date}` }}</span>
          </div>
        </div>
      </div>
      <div class="title">
        <img class="logo" src="static/img/DefaultSystemLogo.png" />
        <span>{{ systemName }}</span>
      </div>
      <div class="alarm">
        <audio ref="bjaudio" loop>
          <source src="@/assets/audio/bj2.mp3" type="audio/mpeg" />
        </audio>
        <div class="bj-wrap" v-show="isAlarm">
          <div class="image-wrap" @click="handleAlarmRecordShow">
            <img class="dengmao" src="static/img/dengmao.png" />
            <img class="deng" :title="'告警记录'" src="static/img/deng.png" />
          </div>
          <span
            v-show="!isPlay"
            :title="'取消静音'"
            class="iconfont"
            style="color: #aaa"
            @click="playOrpause"
            >&#xe61e;</span
          >
          <span
            v-show="isPlay"
            :title="'设置静音'"
            class="iconfont"
            style="color: #aaa"
            @click="playOrpause"
            >&#xe62c;</span
          >
        </div>
        <!-- <AlarmRecord :alarmRecordVisiable="alarmRecordVisiable" @close="handleAlarmRecordClose" /> -->
      </div>
      <div class="on-back-btn" @click="onBack">
        <span>返回</span>
      </div>
    </div>
    <div class="big-screen-box-body">
      <div class="big-screen-box-body-left">
        <div class="left-item-box">
          <span class="item" :style="{ width: tag == 1 ? '50%' : '30%' }">
            <span>
              <span class="nums">{{ statisticalData.alarmCount }}&nbsp;</span>台
            </span>
            <span>设备总数</span>
          </span>
          <span class="item" :style="{ width: tag == 1 ? '50%' : '30%' }">
            <span>
              <span class="nums"
                >{{ statisticalData.onlineAlarmCount }}&nbsp;</span
              >台
            </span>
            <span>在线设备数</span>
          </span>
          <span class="item" @click="onAlarmRecove">
            <span>
              <span
                class="nums"
                :style="{ color: tag == 1 ? 'yellow' : 'green' }"
                >{{ statisticalData.allAlarmRecordTotal }}&nbsp;</span
              >
            </span>
            <span>累计告警数</span>
          </span>
          <span class="item" @click="onAlarmData('10')">
            <span>
              <span
                class="nums"
                :style="{ color: tag !== 1 ? '#ff9900' : 'yellow' }"
                >{{
                  tag == 0
                    ? statisticalData.breakDownAlarmRecordIndustrys
                    : tag == 1
                    ? statisticalData.breakDownAlarmRecordHoseholds
                    : statisticalData.breakDownAlarmRecordRestaurant
                }}&nbsp;</span
              >
            </span>
            <span>当前故障数</span>
          </span>
          <span v-show="tag == 1" class="item" @click="onAlarmData('5')">
            <span>
              <span class="nums" style="color: red"
                >{{ statisticalData.alarmAlarmRecordHoseholds }}&nbsp;</span
              >
            </span>
            <span>当前告警数</span>
          </span>
          <span v-show="tag == 0" class="item" @click="onAlarmData('4')">
            <span>
              <span class="nums" style="color: #ff9900"
                >{{ statisticalData.lowAlarmAlarmRecordIndustrys }}&nbsp;</span
              >
            </span>
            <span>低限报警数</span>
          </span>
          <span v-show="tag == 2" class="item" @click="onAlarmData('4')">
            <span>
              <span class="nums" style="color: #ff9900"
                >{{ statisticalData.lowAlarmAlarmRecordRestaurant }}&nbsp;</span
              >
            </span>
            <span>低限报警数</span>
          </span>
          <span v-show="tag == 0" class="item" @click="onAlarmData('3')">
            <span>
              <span class="nums" style="color: red"
                >{{ statisticalData.highAlarmAlarmRecordIndustrys }}&nbsp;</span
              >
            </span>
            <span>高限报警数</span>
          </span>
          <span v-show="tag == 2" class="item" @click="onAlarmData('3')">
            <span>
              <span class="nums" style="color: red"
                >{{
                  statisticalData.highAlarmAlarmRecordRestaurant
                }}&nbsp;</span
              >
            </span>
            <span>高限报警数</span>
          </span>
        </div>
        <div class="left-item-box">
          <span class="leaderboards-title">
            <span>本月安全排行</span>
            <span @click="onMore">more</span>
          </span>
          <ul>
            <li
              class="leaderboards-item"
              v-for="(item, index) in securityLeaderboards"
              :key="index"
            >
              <span class="name"
                >{{ index + 1 }}&nbsp;&nbsp;{{ item.areaName }}</span
              >
              <span class="scoresline">
                <span class="line" :style="{ width: `${item.score}%` }"></span>
              </span>
              <span class="scores">{{ item.score }}&nbsp;&nbsp;分</span>
            </li>
          </ul>
        </div>
        <div class="left-item-box">
          <span>设备在线状态统计</span>
          <div class="analysis_charts-box">
            <div id="analysis_charts" ref="analysis_charts"></div>
          </div>
        </div>
      </div>
      <div class="big-screen-box-body-mapbox">
        <mapContent :isCommerceType="tag" :isBigScreen="true" />
      </div>
    </div>
    <alarmdata
      :alarmRecordVisiable="alarmDataVisiable"
      :alarmType="tag"
      :index="index"
      @close="close"
    />
    <alarmrecove
      :alarmRecordVisiable="alarmRecordVisiable"
      :alarmType="tag"
      @close="close"
    />
    <leaderboard
      :alarmRecordVisiable="leaderboardVisiable"
      :alarmType="tag"
      @close="close"
    />
    <alarmRecordNow
      :alarmRecordVisiable="alarmRecordNowVisiable"
      @close="handleAlarmRecordClose"
    />
  </div>
</template>

<script>
import mapContent from "./monitor/MonitorView";
import alarmdata from "./AlarmData";
import alarmrecove from "./AlarmRecord";
import leaderboard from "./leaderboards";
import alarmRecordNow from "./AlarmRecordNow";
import { mapState } from "vuex";
const echarts = require("echarts");
export default {
  components: {
    mapContent,
    alarmdata,
    alarmrecove,
    leaderboard,
    alarmRecordNow,
  },
    data() {
    return {
      systemName: "",
      index: "",
      isAlarm: false,
      isPlay: true,
      interval: null,
      interval1: null,
      interval2: null,
      titleBackgroundUrl: "static/img/biaotikuang.png",
      backBtnUrl: "static/img/backBtn.png",
      left1Url: "static/img/left1.png",
      left2Url: "static/img/left2.png",
      left3Url: "static/img/left3.png",
      mapboxUrl: "static/img/backBtn.png",
      myChart: {},
      times: "",
      tag: "0",
      statisticalData: {},
      alarmDataVisiable: false,
      alarmRecordVisiable: false,
      leaderboardVisiable: false,
      alarmRecordNowVisiable: false,
      online: "100",
      offline: "10",
      oldalarm: [],
      securityLeaderboards: [],
    };
  },
  created() {
    console.log("默认图层", this.defaultMap);
    this.systemName = this.$db.get("systemName");
    this.showtime();
    this.tag = this.defaultMap + "";
    this.getStatistical();
    this.getAreaScore();
    this.getAlarmRecordData();
    // this.drawLine()
    this.interval1 = setInterval(() => {
      this.showtime();
    }, 1000);
    window.onresize = () => {
      setTimeout(() => {
        this.myChart.resize();
      }, 100);
    };
  },
  computed: {
    ...mapState({
      defaultMap: (state) => state.setting.defaultMap,
    }),
  },
  watch: {
    isAlarm() {
      this.isPlay = this.isAlarm;
      // console.log(this.isAlarm);
      if (this.isAlarm) {
        this.$refs.bjaudio.play();
      } else {
        this.$refs.bjaudio.pause();
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.interval1);
    clearInterval(this.interval2);
    this.interval = null;
    this.$refs.bjaudio.pause();
    console.log("销毁页面");
  },
  methods: {
    handleAlarmRecordShow() {
      this.alarmRecordNowVisiable = true;
    },
    handleAlarmRecordClose() {
      this.alarmRecordNowVisiable = false;
    },
    playOrpause() {
      this.isPlay = !this.isPlay;
      if (this.isPlay) {
        this.$refs.bjaudio.play();
      } else {
        this.$refs.bjaudio.pause();
      }
    },
    arrDifferent(arr1, arr2) {
      if (arr1.length > arr2.length) {
        return false;
      } else {
        let set = new Set(arr2);
        let oriSetSize = set.size;
        arr1.forEach((item) => {
          set.add(item);
        });
        if (set.size > oriSetSize) {
          return true;
        } else {
          return false;
        }
      }
    },
    getAlarmRecordData() {
      //获取报警状态
      let self = this;
      this.$get("/monitor/monitorAlarm").then((r) => {
        // console.log("ba", r.data);
        let alarm = r.data;
        if (alarm.length == 0) {
          this.isAlarm = false;
          this.oldalarm = alarm;
        } else if (this.oldalarm.length == 0 && alarm.length > 0) {
          this.isAlarm = true;
          this.isPlay = true;
          this.$refs.bjaudio.play();
          this.oldalarm = alarm;
        } else if (this.oldalarm.length > 0 && alarm.length > 0) {
          let status = this.arrDifferent(this.oldalarm, alarm);
          if (status) {
            this.isAlarm = true;
            this.isPlay = true;
            this.$refs.bjaudio.play();
            this.oldalarm = alarm;
          }
          // console.log("status", status);
        } else {
          this.isAlarm = false;
          console.log("else");
        }
        if (!this.interval) {
          this.interval = setInterval(() => {
            self.getAlarmRecordData();
          }, 5000);
        }
      });
    },
    onBack() {
      this.$router.push("/home");
      this.$refs.bjaudio.pause();
    },
    getStatistical() {
      let self = this;
      this.$get("/display-platform/getStatistical", {
        areaType: this.tag,
      }).then((res) => {
        this.statisticalData = res.data;
        let offlinealarm = res.data.alarmCount - res.data.onlineAlarmCount;
        this.online = res.data.onlineAlarmCount;
        this.offline = offlinealarm;
        this.drawLine();
        if (!this.interval2) {
          this.interval2 = setInterval(() => {
            // console.log("轮询");
            self.getStatistical();
          }, 5000);
        }
      });
    },
    getAreaScore() {
      this.$get("/display-platform/getAreaScore", {
        alarmType: this.tag,
      }).then((res) => {
        console.log("排行榜", res.data);
        this.securityLeaderboards = res.data.rows;
      });
    },
    onBusiness() {
      this.tag = "0";
      this.getStatistical();
      this.getAreaScore();
    },
    onHome() {
      this.tag = "1";
      this.getStatistical();
      this.getAreaScore();
    },
    onRestaurant() {
      this.tag = "2";
      this.getStatistical();
      this.getAreaScore();
    },
    onAlarmData(index) {
      this.alarmDataVisiable = true;
      console.log("index", index);
      this.index = index;
    },
    onAlarmRecove() {
      this.alarmRecordVisiable = true;
    },
    onMore() {
      this.leaderboardVisiable = true;
    },
    close() {
      this.alarmDataVisiable = false;
      this.alarmRecordVisiable = false;
      this.leaderboardVisiable = false;
    },
    showtime() {
      var today, hour, second, minute, year, month, date;
      var strDate;
      today = new Date();
      var n_day = today.getDay();
      switch (n_day) {
        case 0:
          {
            strDate = "星期日";
          }
          break;
        case 1:
          {
            strDate = "星期一";
          }
          break;
        case 2:
          {
            strDate = "星期二";
          }
          break;
        case 3:
          {
            strDate = "星期三";
          }
          break;
        case 4:
          {
            strDate = "星期四";
          }
          break;
        case 5:
          {
            strDate = "星期五";
          }
          break;
        case 6:
          {
            strDate = "星期六";
          }
          break;
        case 7:
          {
            strDate = "星期日";
          }
          break;
      }
      year = today.getYear() + 1900;
      month =
        today.getMonth() + 1 < 10
          ? "0" + (today.getMonth() + 1)
          : today.getMonth() + 1;
      date = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
      hour = today.getHours() < 10 ? "0" + today.getHours() : today.getHours();
      minute =
        today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes();
      second =
        today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();
      let tiems = {
        strDate,
        year,
        month,
        date,
        hour,
        minute,
        second,
      };
      this.times = tiems;
    },
    drawLine() {
      // if(!this.lineData) return
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(this.$refs.analysis_charts);
      // 绘制图表

      let option = this.getOption();
      this.myChart.setOption(option);
    },
    getOption() {
      let picPrenct = "";
      if (this.online == 0) {
        picPrenct = 0;
      } else if (this.online !== 0 && this.offline == 0) {
        picPrenct = 100;
      } else {
        picPrenct = (
          100 *
          (this.online / (this.online + this.offline))
        ).toFixed(2);
      }
      let option = {
        backgroundColor: "#0A1326",
        title: {
          text: `${picPrenct}%`,
          subtext: "在线率",
          x: "center",
          y: "center",
          textStyle: {
            color: "#fff",
            fontSize: this.fontSize(0.18),
            fontWeight: "normal",
          },
          subtextStyle: {
            color: "rgba(255,255,255,.45)",
            fontSize: this.fontSize(0.12),
            fontWeight: "normal",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          x: "center",
          y: "bottom",
          data: ["rose3", "rose5", "rose6", "rose7", "rose8"],
        },
        calculable: true,
        series: [
          {
            name: "设备",
            type: "pie",
            radius: ["55%", "70%"],
            center: ["50%", "50%"],
            data: [
              {
                value: this.online,
                name: "在线",
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "#f6e3a1",
                    },
                    {
                      offset: 1,
                      color: "#ff4236",
                    },
                  ]),
                },
                label: {
                  color: "rgba(255,255,255,.45)",
                  fontSize: this.fontSize(0.12),
                  formatter: `在线{a|${this.online}}个`,
                  rich: {
                    a: {
                      color: "#fff",
                      fontSize: this.fontSize(0.12),
                      lineHeight: this.fontSize(0.3),
                    },
                  },
                },
              },
              {
                value: this.offline,
                name: "离线",
                itemStyle: {
                  color: "transparent",
                },
              },
            ],
          },
          {
            name: "设备",
            type: "pie",
            radius: ["60%", "65%"],
            center: ["50%", "50%"],
            data: [
              {
                value: this.online,
                name: "在线",
                itemStyle: {
                  color: "transparent",
                },
              },
              {
                value: this.offline,
                name: "离线",
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "#348fe6",
                    },
                    {
                      offset: 1,
                      color: "#625bef",
                    },
                  ]),
                },
                label: {
                  color: "rgba(255,255,255,.45)",
                  fontSize: this.fontSize(0.12),
                  formatter: `离线{a|${this.offline}}个`,
                  rich: {
                    a: {
                      color: "#fff",
                      fontSize: this.fontSize(0.12),
                      lineHeight: this.fontSize(0.3),
                    },
                  },
                },
              },
            ],
          },
        ],
      };
      return option;
    },
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/utils/utils.less";
@keyframes scaleDraw {
  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
  0% {
    transform: scale(0.8); /*开始为原始大小*/
    opacity: 0.8;
  }
  20% {
    transform: scale(0.9); /*放大1.1倍*/
    opacity: 0.6;
  }
  40% {
    transform: scale(1); /*放大1.1倍*/
    opacity: 0.4;
  }
  60% {
    transform: scale(1.2); /*放大1.1倍*/
    opacity: 1;
  }
  80% {
    transform: scale(1); /*放大1.1倍*/
    opacity: 0.6;
  }
  100% {
    transform: scale(0.8);
    opacity: 0.8;
  }
}
.btn-active {
  background-color: #003399;
}
ul,
li {
  list-style: none;
  padding: 0px;
  margin: 0px;
}
.big-screen-box {
  width: 100vw;
  height: 100vh;
  background-color: #0a1326;
  display: flex;
  flex-direction: column;
  &-head {
    height: 7vh;
    display: flex;
    justify-content: space-between;
    &-left {
      margin-left: 1vw;
      display: flex;
      align-items: center;
      color: white;
      // background-color: #fff;
      .btn-box {
        display: flex;
        .btn {
          display: block;
          width: 3.5vw;
          height: 3.2vh;
          text-align: center;
          line-height: 3.2vh;
          font-size: 0.65vw;
          border: 0.1vw blue solid;
          &:hover {
            cursor: pointer;
          }
        }
      }
      .time-box {
        margin-left: 2vw;
        display: flex;
        // align-items: center;
        div:first-child {
          font-size: 2vw;
        }
        div:last-child {
          margin-left: 1vw;
          font-size: 0.6vw;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
    }
    .title {
      // background: azure;
      background: url("../../../static/img/biaotikuang.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 7vh;
      width: 37vw;
      display: flex;
      justify-content: center;
      align-items: center;
      .logo {
        height: 45%;
        margin-right: 1vw;
      }
      color: white;
      font-size: 1.5vw;
      font-family: "Arial Normal", "Arial";
      font-weight: 400;
      font-style: normal;
    }
    .alarm {
      width: 4vw;
      height: 4vw;
      // background-color: #fff;
      position: fixed;
      right: 15vw;
      top: 1vh;
      // display: flex;

      .bj-wrap {
        // position: fixed;
        // z-index: 50;
        // top: 0;
        // left: 300px;
        // right: 150px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        // background: rgb(197, 120, 120);
        // flex-direction: column;
        .image-wrap {
          width: 2vw;
          height: 2vw;
          display: flex;
          justify-content: center;
          align-items: center;
          // background: white;
          position: relative;
          cursor: pointer;
          .dengmao {
            width: 1.6vw;
            height: 1.5vw;
            position: absolute;
            top: 2px;
            animation: scaleDraw 0.75s linear infinite;
          }
          .deng {
            width: 1.5vw;
            height: 1.5vw;
          }
        }
        & span {
          cursor: default;
        }
      }
    }

    .on-back-btn {
      &:hover {
        cursor: pointer;
      }
      width: 6vw;
      height: 5vh;
      background: url("../../../static/img/backBtn.png") no-repeat;
      background-size: 100% 100%;
      // background-color: wheat;
      color: white;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 0.7vw;
      span {
        margin-top: -0.7vh;
        margin-right: 1.5vw;
      }
    }
  }
  &-body {
    flex: 1;
    display: flex;
    // margin-bottom: 1vh
    // padding-bottom: 5vh;
     &-left {
      width: 18vw;
      // background-color: cadetblue;
      min-width: 320px;
      margin: 1vw;
      color: white;
      display: flex;
      flex-direction: column;
      position: relative;
      z-index: 10; /* 确保左侧面板显示在地图之上 */
      .left-item-box {
        border: 0.1vw #1c2475 solid;
        background: linear-gradient(#1c2475, #1c2475) left top,
          linear-gradient(#1c2475, #1c2475) left top,
          linear-gradient(#1c2475, #1c2475) right top,
          linear-gradient(#1c2475, #1c2475) right top,
          linear-gradient(#1c2475, #1c2475) left bottom,
          linear-gradient(#1c2475, #1c2475) left bottom,
          linear-gradient(#1c2475, #1c2475) right bottom,
          linear-gradient(#1c2475, #1c2475) right bottom;
        background-repeat: no-repeat;
        background-size: 0.2vw 1vw, 1vw 0.2vw;
      }
      div:first-child {
        height: 20%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        align-items: center;
        .item {
          width: 30%;
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          font-size: 0.6vw;
          &:hover {
            cursor: pointer;
          }
          .nums {
            font-size: 1.3vw;
            color: green;
          }
        }
      }
      div:nth-child(2) {
        height: 45%;
        margin-top: 0.2vw;
        margin-bottom: 0.2vw;
        padding: 0.3vw 1vw;
        display: flex;
        flex-direction: column;
        .leaderboards-title {
          display: inline-block;
          width: 100%;
          height: 3.5vh;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span:first-child {
            font-size: 0.7vw;
            margin-left: 0.5vw;
            position: relative;
            &::before {
              content: "";
              display: block;
              width: 0.3vw;
              height: 1.5vh;
              background-color: #213de4;
              position: absolute;
              left: -0.5vw;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          span:last-child {
            color: dodgerblue;
            font-size: 0.7vw;
            &:hover {
              cursor: pointer;
            }
          }
          border-bottom: 1px dodgerblue solid;
        }
        ul {
          // background-color: cadetblue;
          flex: 1;
          display: flex;
          flex-direction: column;
          // justify-content: space-between;
          padding-top: 10px;
        }
        .leaderboards-item {
          display: flex;
          align-items: center;
          font-size: 0.65vw;
          // background: aqua;
          height: 10%;
          .name {
            width: 38%;
            .textOverflow();
          }
          .scoresline {
            // display: inline-block;
            width: 38%;
            height: 45%;
            // background-color: aquamarine;
            display: inline-flex;
            align-items: center;
            // line-height: 45%;
            // background-color: white;
            margin: 0 10px;
            .line {
              display: inline-block;
              background: green;
              height: 50%;
              // line-height: 60%;
            }
          }
          .scores {
            width: 15%;
            text-align: right;
          }
        }
      }
      div:last-child {
        flex: 1;
        padding: 15px;
        display: flex;
        flex-direction: column;
        span:first-child {
          padding: 0.3vw 1vw;
          font-size: 0.7vw;
          display: block;
          position: relative;
          // margin-left: 0.3vw;
          &::before {
            content: "";
            display: block;
            width: 0.3vw;
            height: 1.5vh;
            background-color: #213de4;
            position: absolute;
            left: 0.4vw;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .analysis_charts-box {
          flex: 1;
          width: 100%;
          // display: block;
          // height: 100%;
          // background-color: #fff;
          // position: relative;
          // background-color: rgb(190, 221, 248);
        }
        #analysis_charts {
          // position: absolute;
          // left: 0;
          // bottom: 0;
          // left: 50%;
          // transform: translateX(-50%);
          width: 100%;
          height: 100%;
          // background-color: #fff;
          padding: 0;
        }
      }
    }
     &-mapbox {
      flex: 1;
      margin: 1vw 1vw 1vw 0;
      border: 0.1vw #1c2475 solid;
      padding: 0.2vw;
      overflow: hidden;
      position: relative;
      z-index: 0; /* 确保地图容器在正确的层级 */
      background: linear-gradient(#0000ff, #0000ff) left top,
        linear-gradient(#0000ff, #0000ff) left top,
        linear-gradient(#0000ff, #0000ff) right bottom,
        linear-gradient(#0000ff, #0000ff) right bottom;
      background-repeat: no-repeat;
      background-size: 0.2vw 2vw, 1.5vw 0.2vw;
    }
  }
}

// 确保MonitorView中的内容有足够高的z-index
#pageContent.big-screen-mode {
  position: relative;
  z-index: 1000;
}

// #pageContent.big-screen-mode .content,
// #pageContent.big-screen-mode .event-panel {
//   z-index: 2000 !important;
//   position: relative;
// }

// 直接给地图添加暗色滤镜
#allmap .leaflet-tile-container img {
  filter: invert(1) hue-rotate(180deg) brightness(0.9) contrast(1.1) !important;
}

#allmap .leaflet-marker-pane img {
  filter: none !important;
}

.iconfont {
  font-size: 0.8vw;
}
</style>


// WEBPACK FOOTER //
// src/views/bigscreen/bigScreen.vue